<template>
  <el-dialog
    :visible.sync="visible"
    width="760px"
    :before-close="handleClose"
  >
    <template slot="title">
      <div class="dialog-title">
        <img src="@/assets/images/upload.png" style="color: #1990FF; width: 20px; height: 20px; margin-right: 6px;" />
        <span>上报收款信息</span>
      </div>
    </template>

    <!-- 提示 -->
    <div class="tip-banner">
      <i class="el-icon-warning" style="color: #faad14; margin-right: 6px;"></i>
      请填写您的银行卡信息，用于接收佣金打款
    </div>

    <el-form ref="formRef" :model="form" :rules="rules" label-position="top" label-width="0" v-loading="isLoading">
      <el-form-item label="姓名" prop="payeeName">
        <el-input v-model="form.payeeName" placeholder="请输入持卡人姓名"></el-input>
      </el-form-item>
      <el-form-item label="银行卡号" prop="bankCardNo">
        <el-input v-model="form.bankCardNo" placeholder="请输入银行卡号"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="bankName">
        <el-input v-model="form.bankName" placeholder="请输入开户行名称（如：中国工商银行上海分行）"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCardNo">
        <el-input v-model="form.idCardNo" placeholder="请输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobilePhone">
        <el-input v-model="form.mobilePhone" placeholder="请输入手机号"></el-input>
      </el-form-item>
    </el-form>

    <div class="warm-tip">
      <div class="warm-tip__title">
        <i class="el-icon-warning" style="color: #faad14; margin-right: 4px;"></i>温馨提示：
      </div>
      <div class="warm-tip__content">
        <p>1.请确保银行卡信息真实有效</p>
        <p>2.身份证号仅用于财务核对，不会对外泄露</p>
        <p>3.如信息有变，请及时更新</p>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="footer-buttons">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确认提交</el-button>
    </div>

    <!-- 变更日志 -->
    <div class="change-log-section">
      <div class="log-title">日志</div>
      <el-table
        :data="logList"
        border
        v-loading="logLoading"
        max-height="280"
        style="width: 100%"
      >
        <el-table-column prop="createTime" label="日期" width="160" align="center"></el-table-column>
        <el-table-column prop="changeAfter" label="变更内容" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="changeBefore" label="变更前内容" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operatorName" label="操作人" min-width="120" show-overflow-tooltip align="center"></el-table-column>
      </el-table>
      <el-pagination
        v-if="logTotal > 0"
        small
        layout="total, prev, pager, next"
        :total="logTotal"
        :page-size="logPageSize"
        :current-page.sync="logPage"
        @current-change="getLogList"
        style="margin-top: 12px; text-align: right;"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'UploadPayInfoDialog',
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      submitting: false,
      isLoading: false,
      form: {
        payeeName: '',
        bankCardNo: '',
        bankName: '',
        idCardNo: '',
        mobilePhone: ''
      },
      rules: {
        payeeName: [{ required: true, message: '请输入持卡人姓名', trigger: 'blur' }],
        bankCardNo: [{ required: true, message: '请输入银行卡号', trigger: 'blur' }],
        bankName: [{ required: true, message: '请输入开户行名称', trigger: 'blur' }],
        idCardNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号格式不正确', trigger: 'blur' }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ]
      },
      logList: [],
      logLoading: false,
      logPage: 1,
      logPageSize: 5,
      logTotal: 0
    }
  },
  computed: {
    visible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getPayInfo()
        this.getLogList()
      }
    }
  },
  created() {
  },
  methods: {
    handleClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
      this.$emit('input', false)
      this.$emit('close')
    },
    getPayInfo() {
      this.isLoading = true
      this.$http('get', 'mall/bdM2sSettlementChannelReceipt/get', {}).then(res => {
        if (res) {
          this.form.payeeName = res.payeeName || ''
          this.form.bankCardNo = res.bankCardNo || ''
          this.form.bankName = res.bankName || ''
          this.form.idCardNo = res.idCardNo || ''
          this.form.mobilePhone = res.mobilePhone || ''
        }
      }).catch(() => {}).finally(() => this.isLoading = false)
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.submitting = true
        this.$http('post', 'mall/bdM2sSettlementChannelReceipt/save', { ...this.form }).then(() => {
          this.$message.success('保存成功')
          this.$emit('on-success')
          this.getLogList() // 刷新日志
          this.handleClose()
        }).catch(() => {}).finally(() => {
          this.submitting = false
        })
      })
    },
    getLogList() {
      this.logLoading = true
      this.$http('get', 'mall/bdM2sSettlementChannelReceipt/log/list', {
        page: this.logPage,
        pageSize: this.logPageSize
      }).then(res => {
        this.logList = res && res.data || []
        this.logTotal = res && res.total || 0
      }).catch(() => {}).finally(() => {
        this.logLoading = false
      })
    }
  }
}
</script>

<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.tip-banner {
  background: #FFFBE6;
  border: 1px solid #FFE58F;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.warm-tip {
  margin-top: 8px;
}
.warm-tip__title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
}
.warm-tip__content {
  font-size: 13px;
  color: #666;
  line-height: 22px;
}
.warm-tip__content p {
  margin: 0;
}
.footer-buttons {
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid #e8e8e8;
}
.change-log-section {
  margin-top: 20px;
}
.log-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}
</style>
